import { Scene } from "phaser";
import { GButton } from "../gameobjects/GButton";
import { unixToDate , combinations} from '../utils';


const COLOR_BLUE = "#00FFF0";
const COLOR_DIMM = "#757B8C";

export class DetailsScene extends Scene {
    
    constructor() {
        super("DetailsScene");
    }

    
    init(){

        this.MyScenes = []
        this.scene.manager.scenes.forEach(scene => {

            if (scene.scene.isActive()) {
                // Pause the scene
                if (scene.scene.key != "HudScene"){
                    scene.scene.pause();
                    //console.log(`Paused scene: ${scene.scene.key}`);
                    this.MyScenes.push(scene.scene.key)
                }
                
                
            }
        });
    }

    // Optional: Remove the event listener if you need to clean up
    destroy() {
        this.events.off('shutdown', this.onShutdown, this);
    }

    onShutdown() {
        // console.log(
        //     "SHOT DOWN"
        // )

        this.scene.manager.scenes.forEach(scene => {
        // Check if the scene is paused
            if (scene.scene.isPaused()) {
                // Resume the scene
                scene.scene.resume();
                //console.log(`Resumed scene: ${scene.scene.key}`);
            }
        });
        this.events.off('shutdown', this.onShutdown, this);
    }

    create(){

       
        this.numberRand = 0
        // Create a download button as an HTML element
        // const downloadButton = document.createElement('a');
        // downloadButton.innerText = 'Download T&C PDF';
        // downloadButton.href = 'assets/Lotto6 Game Rules (General).pdf'; // Specify the path to the PDF file
        // downloadButton.setAttribute('download', 'Lotto6 Game Rules (General).pdf'); // Set file name for download
        // downloadButton.style.position = 'absolute';
        // downloadButton.style.top = '20px';
        // downloadButton.style.left = '20px';
        // downloadButton.style.padding = '10px 20px';
        // downloadButton.style.backgroundColor = '#3498db';
        // downloadButton.style.color = '#fff';
        // downloadButton.style.textDecoration = 'none';
        // downloadButton.style.borderRadius = '5px';

         // Append the button to the game's DOM container
         //this.add.dom(0, 0, downloadButton);


     
        // Append the button to the game's DOM container
        //this.add.dom(0, 0, downloadButton);

            this.events.on('shutdown', this.onShutdown, this);
            // Create a transparent input zone that covers the entire screen
            this.inputZone = this.add.zone(0, 0, this.scale.width, this.scale.height)
                .setOrigin(0)
                .setInteractive(); // Make it interactive to capture clicks

                     
            this.cameras.main.setBackgroundColor('rgba(21, 21, 21, 0.85)');

            this.buttonClickSound = this.sound.add('button-click');
            // ""
            // "Bet Types"
            // ""

            this.graphics = this.add.graphics();

            this.graphics.fillStyle(0x05022D, 1);

            //this.graphics.fillRoundedRect(this.scale.width/2-343, 32, 343*2 , this.scale.height-64, 32);
            this.graphics.fillRoundedRect(this.scale.width/2-343, 32, 343*2 , this.scale.height/2, 32);



            var gridSizer = this.rexUI.add.gridSizer(this.scale.width/2-343+32, 160, {
                column: 3,  // col: 0
                row: 1,
                // columnProportions: undefined,
                // rowProportions: undefined,
                columnProportions: [1, 1, 1], // make both columns 50%
                space: {
                    left: 0, right: 0, top: 20, bottom: 0,
                    column: 14,
                    row: 5
                },
                
                // space: {
                //     left: 0, right: 0, top: 0, bottom:0,
                //     column: 0, // [0, 0, 0]
                //     row: 0,    // [0, 0, 0]
                //     indentLeftOdd: 0, indentLeftEven: 0,
                //     indentTopOdd: 0, indentTopEven: 0,
                // },
            
                // createCellContainerCallback: function(scene, x, y, config) {
                //     config.expand = true;
                //     return cellContainer;
                // },
            
                // width: undefined,
                // height: undefined
            });

            gridSizer.setOrigin(0,0.5)
            //gridSizer.addBackground(this.rexUI.add.roundRectangle(0, 0, 1, 1, 0, 0xff0000))

            this.HowToPlay = this.add.text(-4, 0, `How to Play`.toUpperCase(),  { fontFamily: 'Oswald', fontSize: 32, color: COLOR_BLUE }).setOrigin(0).setInteractive();
            this.HowToPlay.setFontStyle('700')

            this.BetType = this.add.text(0, 0, `Bet Types`.toUpperCase(),  { fontFamily: 'Oswald', fontSize: 32, color: COLOR_DIMM }).setOrigin(0).setInteractive();
            this.BetType.setFontStyle('700')

            this.PrizeStructure = this.add.text(0, 0, `Prize Structures`.toUpperCase(),  { fontFamily: 'Oswald', fontSize: 32, color: COLOR_DIMM }).setOrigin(0).setInteractive();
            this.PrizeStructure.setFontStyle('700')
            

            //const that = this
            this.BetType.on('pointerup', () => {
                this.BetType.setColor(COLOR_BLUE);

                this.HowToPlay.setColor(COLOR_DIMM);
                this.PrizeStructure.setColor(COLOR_DIMM);

                this.panelBetTypes.setVisible(true)
                this.panelHowToPlay.setVisible(false)
                this.panelPrizeStructure.setVisible(false)

                this.graphics.clear()
                this.graphics.fillStyle(0x05022D, 1);
                this.graphics.fillRoundedRect(this.scale.width/2-343, 32, 343*2 , this.scale.height-64, 32);
               

            });

            this.HowToPlay.on('pointerup', (that) => {
                this.HowToPlay.setColor(COLOR_BLUE);

                this.BetType.setColor(COLOR_DIMM);
                this.PrizeStructure.setColor(COLOR_DIMM);

                this.panelBetTypes.setVisible(false)
                this.panelHowToPlay.setVisible(true)
                this.panelPrizeStructure.setVisible(false)

                this.graphics.clear()
                this.graphics.fillStyle(0x05022D, 1);
                this.graphics.fillRoundedRect(this.scale.width/2-343, 32, 343*2 , this.scale.height/2, 32);

            });


            this.PrizeStructure.on('pointerup', (that) => {
                this.PrizeStructure.setColor(COLOR_BLUE);

                this.BetType.setColor(COLOR_DIMM);
                this.HowToPlay.setColor(COLOR_DIMM);

                this.panelBetTypes.setVisible(false)
                this.panelHowToPlay.setVisible(false)
                this.panelPrizeStructure.setVisible(true)

                this.graphics.clear()
                this.graphics.fillStyle(0x05022D, 1);
                this.graphics.fillRoundedRect(this.scale.width/2-343, 32, 343*2 , this.scale.height-64, 32);

            });


            gridSizer.add( this.HowToPlay,
                {
                    column: 0,
                    row: 0,
                    align: 'left',
                    padding: {left: 0, right: 0, top: 0, bottom: 0},
                    // expand: false,        // expand: {width, height}
                    // key: undefined,
                    // offsetX: 0,
                    // offsetY: 0,
                    // offsetOriginX: 0,
                    // offsetOriginY: 0,
                }
            );

            gridSizer.add( this.BetType,
                {
                    column: 1,
                    row: 0,
                    align: 'center',
                    padding: {left: 0, right: 0, top: 0, bottom: 0},
                }
            );

            gridSizer.add( this.PrizeStructure,
                {
                    column: 2,
                    row: 0,
                    align: 'left',
                    padding: {left: 0, right: 0, top: 0, bottom: 0},
                }
            );

            gridSizer.layout();
            gridSizer.layout();

          



            this.title = this.add.text(this.scale.width/2-343+32, 64, `DETAILS`,  { fontFamily: 'Oswald', fontSize: 48, color: '#ffffff' }).setOrigin(0);
            this.title.setFontStyle('700')
    
            this.buttonSprite = this.add.sprite(this.scale.width/2 +343-64,88, "pack" ,'x-icon.png').setInteractive();
            this.buttonSprite.setTint(0x757B8C)
            this.buttonSprite.setScale(2)
          
            this.buttonSprite.on('pointerup', () => {
                this.buttonClickSound.play();
                this.tweens.add({
                    targets: this,
                    scaleX: 0.8 ,
                    scaleY: 0.8,
                    duration: 50, // Duration of the tween (in milliseconds)
                    ease: 'Power2',
                    onComplete: () => {
                        this.scene.stop()

                        // this.scene.manager.scenes.forEach((scene) => {
                        //     if (scene.scene.settings.active && this.shouldStopScene(scene)) {
                        //         scene.scene.stop(); // Stop the scene if active and matches criteria
                        //         //console.log(`Stopped scene: ${scene.scene.key}`);
                        //     }
                        // });

                        //this.scene.launch("MenuScene" , {})
                    }
                });
            
            });


            this.CreateBetTypePanel();
            this.CreateHowToPlayPanel();
            this.CreatePrizeStructurePanel();


            // if (!this.textures.exists('panelPrizeStructure')) {

            //     // 2. Create a RenderTexture to capture the panel
            //     //const renderTexture = this.add.renderTexture(0, 0, this.panelPrizeStructure.width, this.panelPrizeStructure.height);
            //     const renderTexture = this.add.renderTexture(0, 0, this.scale.width, this.scale.height);

            //     // 3. Draw the panel onto the RenderTexture
            //     renderTexture.draw(this.panelBetTypes.getAllChildren(),this.scale.width/2,this.scale.height/2);

            //     renderTexture.saveTexture('panelPrizeStructure', renderTexture.texture);
            //     renderTexture.setVisible(false)
            //     console.log(this.panelBetTypes.getAllChildren())
            // }
          
            // // 4. Optional: Display the RenderTexture as an image somewhere else in the scene
            // const renderedImage = this.add.image(this.scale.width/2, this.scale.height/2, 'panelPrizeStructure');
            // renderedImage.setOrigin(0.5);
            // renderedImage.setDisplaySize(this.scale.width, this.scale.height);
            // console.log("renderedImage", renderedImage)



    }


    downloadPDF(url, filename) {
        // Create a hidden link element
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);

        // Append link to body (required for Firefox)
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Remove the link after triggering download
        document.body.removeChild(link);
    }

    openPDF(url) {
        // Open the PDF in a new browser tab or window
        window.open(url, '_blank');
    }


CreateBetTypePanel(){

            // Step 1: Create a Scrollable Panel with Blue Background
            this.panelBetTypes = this.rexUI.add.scrollablePanel({
                x: this.scale.width/2-343+32,
                y: 220,
                width: 200*2,
                height: this.scale.height -256,
                scrollMode: 0, // Vertical scroll
                originY: 0,
                originX: 0,

                //background: this.rexUI.add.roundRectangle(0, 0, 2, 2, 10, "0xff0000"),

                panel: {
                    child: this.rexUI.add.sizer({
                        orientation: 'vertical',
                        width:300,
                        space: { item: 30 }, // Space between items
                    }),

                    mask: { padding: 1 },
                },

                space: {
                    left: 0, right: 20, top: 20, bottom: 20,
                    panel: 10,
                }
            }).layout();

            const lottery = this.registry.get('lottery');

             // Step 2: Add Content to the Panel Dynamically
            this.addContentToPanel(this.panelBetTypes, [
                {
                    type: 'info',
                    title: 'Ordinary Entry',
                    paragraphs: [`\u25CF Select six numbers between ${lottery.min_selected_number} and ${lottery.max_selected_number}.`, '\u25CF You win the Group 1 Prize, also known as the Jackpot, if all six chosen numbers match the Winning Numbers.']
                },
                {
                    type: 'table',
                    headers: ["Bet\nType", "Total No.\nSelected", "No. of\nOrdinary\nEntries", "Bet\nAmount"],
                    rows: [
                        ["Ordinary", `${lottery.min_selected_number}`, '1', `$${+lottery.ticket_price}`],
                    ]
                },
                {
                    type: 'info',
                    title: 'System Entry',
                    paragraphs: [`\u25CF Select up to ${lottery.max_selected_number} numbers.`, '\u25CF Choosing more numbers gives you more Ordinary Entries in one bet.']
                },
                {
                    type: 'table',
                    headers: ["Bet\nType", "Total No.\nSelected", "No. of\nOrdinary\nEntries", "Bet\nAmount"],
                    rows: [
                        ["System\n7", '7',   `${combinations(7,6)}`, `$${combinations(7,6)*+lottery.ticket_price}`],
                        ["System\n8", '8',   `${combinations(8,6)}`, `$${combinations(8,6)*+lottery.ticket_price}`],
                        ["System\n9", '9',   `${combinations(9,6)}`, `$${combinations(9,6)*+lottery.ticket_price}`],
                        ["System\n10", '10', `${combinations(10,6)}`, `$${combinations(10,6)*+lottery.ticket_price}`],
                        ["System\n11", '11', `${combinations(11,6)}`, `$${combinations(11,6)*+lottery.ticket_price}`],
                        ["System\n12", '12', `${combinations(12,6)}`, `$${combinations(12,6)*+lottery.ticket_price}`],
                    ]
                },
                {
                    type: 'info',
                    title: 'Quick Pick',
                    paragraphs: ['\u25CF If you do not have any numbers in mind, you may consider the Quick Pick option.', '\u25CF The system will generate a random set of numbers for you.']
                },
            ]);

            this.panelBetTypes.layout();
            this.panelBetTypes.setVisible(false)

}

CreateHowToPlayPanel(){

      // Step 1: Create a Scrollable Panel with Blue Background
      this.panelHowToPlay = this.rexUI.add.scrollablePanel({
        x: this.scale.width/2-343+32,
        y: 220,
        width: 200*2,
        height: this.scale.height -256,
        scrollMode: 0, // Vertical scroll
        originY: 0,
        originX: 0,

        //background: this.rexUI.add.roundRectangle(0, 0, 2, 2, 10, "0xff0000"),

        panel: {
            child: this.rexUI.add.sizer({
                orientation: 'vertical',
                width:300,
                space: { item: 30 }, // Space between items
            }),

            mask: { padding: 1 },
        },

        space: {
            left: 0, right: 20, top: 20, bottom: 20,
            panel: 10,
        }
    }).layout();

    const lottery = this.registry.get('lottery');

     // Step 2: Add Content to the Panel Dynamically
    this.addContentToPanel(this.panelHowToPlay, [
        {
            type: 'info',
            title: 'How to Play',
            linehight: 30,
            paragraphs: [
                `\u25CF To play Lotto6, pick six numbers between 1 and 49.`, 
                '\u25CF The cost per ticket is US$1',
                '\u25CF Draws take place every Friday at 3pm (UTC+08:00)',
                '\u25CF Six Winning Numbers and one Additional Number are drawn each draw.',
                '\u25CF If your chosen numbers include at least three of the Winning Numbers, you win a prize.',
                '\u25CF Payouts will be processed within 24 hours'
            ]
        }
    ]);

    this.panelHowToPlay.layout();
    

}


CreatePrizeStructurePanel(){
     // Step 1: Create a Scrollable Panel with Blue Background
     this.panelPrizeStructure = this.rexUI.add.scrollablePanel({
        x: this.scale.width/2-343+32,
        y: 220,
        width: 200*2,
        height: this.scale.height -256,
        scrollMode: 0, // Vertical scroll
        originY: 0,
        originX: 0,

        //background: this.rexUI.add.roundRectangle(0, 0, 2, 2, 10, "0xff0000"),

        panel: {
            child: this.rexUI.add.sizer({
                orientation: 'vertical',
                width:300,
                space: { item: 30 }, // Space between items
            }),

            mask: { padding: 1 },
        },

        space: {
            left: 0, right: 10, top: 10, bottom: 20,
            panel: 10,
        }
    }).layout();

    const lottery = this.registry.get('lottery');

     // Step 2: Add Content to the Panel Dynamically
    this.addContentToPanel(this.panelPrizeStructure, [
        {
            type: 'info',
            title: 'PRIZE STRUCTURE',
            paragraphs: [
                "If your chosen numbers include at least three of the Winning Numbers, you win a prize. Your prize amount depends on how many of your chosen numbers match the Winning Numbers."
            ]
        },
        {
            type: 'info',
            title: 'PRIZE GROUPS',
            paragraphs: [
                "55% of sales in each draw will be added to the prize pool. The prize pool is for distribution of prizes which may be won for each draw. Allocation of prizes is as follows:"
            ]
        },
        {
            type: 'table',
            headers: ["PRIZE\nGROUP", "MATCHED\nNUMBERS", "PRIZE\nPOOL", "ODDS OF\nWINNING"],
            rows: [
                ["1", `6 winning\nnumbers`, '44% (min. guaranteed amount of USD 10,000)', `1 in\n13,983,816`],
                ["2", `5 winning\nnumbers`, '8.5%', `1 in\n54,200`],
                ["3", `4 winning\nnumbers`, '$50', `1 in\n1,032`],
                ["4", `3 winning\nnumbers`, '$10', `1 in\n698`],
            ]
        },
        {
            type: 'info',
            title: 'MULTIPLE WINNERS',
            paragraphs: [
                "If there is more than one winner within each of Groups 1 to 2, prizes will be divided equally among all winners of the respective Group. The prize amounts for Groups 3 to 4 are fixed."
            ]
        },
        {
            type: 'info',
            title: 'SNOWBALLING',
            paragraphs: [
                "For each draw, a jackpot minimum guarantee amount of USD 10,000 is seeded to that draw’s prize pool. The prize amount snowballs if there is no winner in Group 1 or 2, i.e. it is added to the prize amount within the same Group of the next Draw.",
                "The Group 1 and Group 2 Prize amount will snowball until it is won."
            ]
        },
    ]);

    // // Create a button in Phaser to trigger the download
    // const downloadButton2 = this.add.text(100, 100, 'Download T&C PDF', { fontSize: '24px', color: '#fff' })
    // .setInteractive()
    // .on('pointerdown', () => this.downloadPDF('assets/Lotto6 Game Rules (General).pdf', 'Lotto6 Game Rules (General).pdf'))


    // const openButton = this.add.text(100, 100, 'Open T&C PDF', { fontSize: '24px', color: '#fff' })
    // .setInteractive()
    // .on('pointerdown', () => this.openPDF('assets/Lotto6 Game Rules (General).pdf'));

    // const panelContent = this.panelPrizeStructure.getElement('panel');
    // panelContent.add(openButton); 
    // panelContent.add(downloadButton2); 



    //   // Create an iframe for the PDF
    //   const pdfFrame = document.createElement('iframe');
    //   pdfFrame.src = 'assets/Lotto6 Game Rules (General).pdf'; // Replace with the path to your PDF file
    //   pdfFrame.style.width = '600px'; // Set the desired width
    //   pdfFrame.style.height = '400px'; // Set the desired height
    //   pdfFrame.style.border = 'none';
    //   pdfFrame.style.position = 'absolute';
    //   pdfFrame.style.top = '100px'; // Adjust to position within your game
    //   pdfFrame.style.left = '100px';

    //   // Add the iframe to the Phaser DOM container
    //   const myDom = this.add.dom(0, 0, pdfFrame);
    //   panelContent.add(myDom); 

    this.panelPrizeStructure.layout();
    this.panelPrizeStructure.setVisible(false)

}

// Example function to determine if a scene should be stopped
shouldStopScene(scene) {
    // Add your stopping condition here (e.g., stop all but "MainScene")
    return scene.scene.key !== 'HudScene' && scene.scene.key !== 'MainScene';
}


// Step 3: Function to Add Content Based on JSON Array
addContentToPanel(panel, items) {
    const panelContent = panel.getElement('panel');

    items.forEach(item => {
        let container;

        if (item.type === 'info') {
            // Create Info Container
            container = this.createInfoContainer(item);
        } else if (item.type === 'table') {
            // Create Table Container
            container = this.createTableContainer(item);
            

        }

        if(container !== undefined){

            //console.log("container", container)

            // // Calculate the bounds of the sizer
            // let bounds = container.getBounds();

            // // Use a snapshot of the sizer's area to generate a texture
            // this.game.renderer.snapshotArea(bounds.x, bounds.y, bounds.width, bounds.height, (image) => {
            //     // Add the snapshot as a new texture
            //     this.textures.addImage('sizerTexture', image);
            // });

            // // Add the texture as an image in the scene
            // this.add.image(400, 300, 'sizerTexture');

            // this.numberRand++
            // // Create a render texture with the size of the sizer
            // let rt = this.add.renderTexture(0, 0, 600, 600);

            // // Draw the sizer onto the render texture
            // console.log("container", container.width ,container.originX, container.height , container.originY)
            // console.log(container)
            // rt.draw(container.children, 400, 400);

            // // Add the render texture to the texture manager
            // this.textures.addRenderTexture('sizerTexture' + this.numberRand, rt);

            // rt.setVisible(false)

            // // Use the new texture
            // const mycont = this.add.image(100, 100, 'sizerTexture'+ this.numberRand);

            // Optional: Hide or destroy the original sizer
            //container.setVisible(false); // or sizer.destroy();

            // Add the container to the panel content
            panelContent.add(container); // Make the table take full width , { expand: true }
        }
        
    });

    // Layout the panel again to update the scrollable view
    panel.layout();
}

// Create a Container for "Info" Type
createInfoContainer(item) {
    const infoContainer = this.rexUI.add.sizer({
        orientation: 'vertical',
        width: 312*2,
        align: 'left',
        space: {  left: 20, right:20, top: 20, bottom: 20, item: 5 }, // Space between title and paragraphs
        // background: this.rexUI.add.roundRectangle({
        //     color: "0xff000",
        //     radius: { tl: 8, tr: 8, bl: 8, br: 8 }
        // }),
    });


    infoContainer.addBackground(this.rexUI.add.roundRectangle({
        //color: "0x00000",
        color: "0x02001b",
        radius: { tl: 8, tr: 8, bl: 8, br: 8 },
        //alpha: 0.4
    }))

    // Add Title
    const title = this.add.bitmapText(0, 0,  'oswald2', item.title.toUpperCase(), 30);

    // const title = this.add.text(0, 0, item.title.toUpperCase(), {
    //     fontSize: '30px',
    //     color: '#ffffff',
    //     align: 'left',
    //     fontFamily: 'Oswald',
    // });

    // title.setFontStyle('700')
   

    infoContainer.add(title,{
        align: 'left',
        padding: {left: 0, right: 0, top: 10, bottom: 20},
    });

    // var background = this.add.rectangle(0, 0, 2, 40, 0x888888);
    // infoContainer.addBackground(background)

    // Add Paragraphs
    item.paragraphs.forEach(paragraph => {

        //console.log("item.linehight", item.linehight)
        const text = this.add.bitmapText(0, 0,  'Montserrat-Medium', paragraph, 20).setMaxWidth(300*2).setLineSpacing(80);
        //.setLetterSpacing(20);

        // const text = this.add.text(0, 0, paragraph, {
        //     fontSize: '20px',
        //     color: '#dcdcdc',
        //     align: 'left',
        //     fontFamily: 'Montserrat',
        //     lineSpacing: item.linehight || 10,
        //     wordWrap: { width: 300*2, useAdvancedWrap: true }
            
        // });

        infoContainer.add(text,{
            //proportion: 0,
            align: 'left',
            padding: {left: 0, right: 0, top: 10, bottom: 10},
            // expand: false,
            // key: undefined,
            // index: undefined,
            // minWidth: undefined,
            // minHeight: undefined,
            // fitRatio: 0,  // true
            // offsetX: 0,
            // offsetY: 0,
            // offsetOriginX: 0,
            // offsetOriginY: 0,
        });
    });

    return infoContainer;
}

// Create a Container for "Table" Type
createTableContainer(item) {

    // // Create a rounded rectangle with stroke and fill color
    // const roundedRect = this.rexUI.add.roundRectangle(
    //     200, 200, // x, y position
    //     300, 100, // width, height
    //     20,       // corner radius
    //     0x3498db, // fill color (blue)
    //     0         // fill alpha
    // );

    // // Apply stroke to the rounded rectangle
    // roundedRect.setStrokeStyle(4, 0xffffff); // Stroke thickness and color
    
    const tableContainer = this.rexUI.add.gridSizer({
        column: item.headers.length,
        width: 300*2,
        row: item.rows.length + 1, // +1 for headers
        columnProportions: 1, // Make columns equally sized
        space: { column: 40, row: 20 },
        //background: roundedRect,
        //rowProportions: 1,
    });

    //tableContainer.add(roundedRect, { align: 'center', expand: true });

    // Add Headers
    item.headers.forEach((header, colIndex) => {


        const text = this.add.bitmapText(0, 0,  'oswald2', header.toUpperCase(), 24).setMaxWidth(80*2).setLineSpacing(item.linehight || 20);
        // const text = this.add.text(0, 0, header, {
        //     fontSize: '24px',
        //     fontFamily: 'Oswald',
        //     fontStyle: 'bold',
        //     color: '#E0E4EE',
        //     align: 'center'
        // });

        text.setCenterAlign();
        text.setOrigin(0.5)

        // tableContainer.addBackground(
        //     this.rexUI.add.roundRectangle(0, 0, 0, 0, 0, undefined).setStrokeStyle(2, "0x0000ff", 1)
        // )

        tableContainer.add(text,  colIndex, 0, 'center', 0, true);

    });

    // Add Rows
    item.rows.forEach((row, rowIndex) => {
        const isEvenRow = rowIndex % 2 === 0; // Determine if the row is even

        const rowBackground = this.add.graphics();
        rowBackground
            .fillStyle(isEvenRow ? 0xf0f0f0 : 0xdcdcdc) // Alternate row color
            .fillRect(0, 0, 560, 40); // Adjust the row size as needed

        // // Add the background to the table
        tableContainer.addBackground(rowBackground)// background =this.rexUI.add.roundRectangle(0, 0, 2, 2, 10, "0x0000ff");


        
        row.forEach((cell, colIndex) => {
            
            const text = this.add.bitmapText(0, 0,  'Montserrat-Medium', cell, 22).setMaxWidth(80*2).setLineSpacing(item.linehight || 20);

            // const text = this.add.text(0, 0, cell, {
            //     fontSize: '24px',
            //     fontFamily: 'Montserrat',
            //     color: '#F9F9FF',
            //     align: 'center',
            //     lineSpacing: 10,
            //     wordWrap: { width:  80*2, useAdvancedWrap: true }
            // });
            text.setCenterAlign();
            text.setOrigin(0.5)

            tableContainer.add(text, colIndex, rowIndex + 1, 'center', 0, false);
        });
    });


//    tableContainer.layout();

    //tableContainer.setMinSize(this.scene.width, 500).layout();
    return tableContainer;
}



}